import { atom } from "recoil";

export const gamesEditModalStore = atom({
	key: "gamesEditModalStore",
	default: {
		show: false,
		loaded: true,
		gameID: false,
		id: false,
		editID: false,
		providerID: false,
		section: [],
		badges: [],
		editAllGames: false,
		currentOption: {
			section: [],
			badges: [],
		},
		badgeAssignments: [],
		categoryID: [],
		name: "",
		poster: "",
		volatility: 65,
		rtp: 95,
		newPoster: false,
		newBigPoster: false,
		params: [],
		tags: [],
		tagIds: [],
		biases: {
			bias: 0,
			auto: true,
			from: "1970-01-01",
			to: "9999-12-31",
			providerID: 0,
		},
	},
});
